import { Element } from "@api/models/Element";
import { EventMembership } from "@api/models/EventMemberShip";
import { DateTime } from "luxon";
import { EventInterface } from "../types/EventInterface";
import { ProgramDataHelper } from "./ProgramDataHelper";
import {WebinarInfo} from "@api/models/WebinarInfo";
import {Rating} from "@api/models/Rating";
import i18n from "@service/locale/i18";

export class  ProgramDataMapper {
    public static getFullAgenda(source: Element, dataHelper: ProgramDataHelper) {
        return
    }

    /** include here param dataHelper by this */

    public static getCommonAgenda(source: Element, speakers: EventMembership[], isUpcoming: boolean): EventInterface {
        return {
            id: source.id,
            title: source.title,
            beginAt: DateTime.fromISO(source.beginAt),
            endAt: DateTime.fromISO(source.endAt),
            isClosed: source?.isClosed === true,
            isStarted: source?.isStarted === true,
            isUpcoming: isUpcoming,
            isManualControlled: source?.isManualControlled === true,
            speakers: speakers || [],
            type: source.type,
            description: source.description,
            partnerId: source.partnerId,
            tagsIds: source.tagsIds
        }
    }

    public static toEventInterface(
        item: Element,
        speakers: { [key: string]: EventMembership[] },
        webinarsInfo: { [key: string]: WebinarInfo },
        likes: { [key: string]: Rating },
        comments: Record<string, number>
    ): EventInterface {
        return  {
            id: item.id,
            title: item.title,
            start: item.beginAt, //DateTime.fromISO(item.beginAt, {setZone: true}).toISO({ includeOffset: false }),
            end: item.endAt, //DateTime.fromISO(item.endAt, {setZone: true}).toISO({ includeOffset: false }),
            beginAt: DateTime.fromISO(item.beginAt),
            endAt: DateTime.fromISO(item.endAt),
            isClosed: item?.isClosed === true,
            isStarted: item?.isStarted === true,
            isManualControlled: item?.isManualControlled === true,
            speakers: speakers[item.id] || [],
            type: item.type,
            likes: likes[item.id],
            webinarInfo: webinarsInfo[item.id] || {},
            comments: comments[item.id] || 0,
            statusTitle: i18n.t('common.userLoggedIn').toString(),
            description: item.description,
            onlineParams: item.onlineParams,
            onlineProvider: item.onlineProvider,
            partnerId: item.partnerId,
            tagsIds: item.tagsIds ?? []
        }
    }
}
